/**
 * AGROMX Frontend - Login View
 * Vista de inicio de sesión
 */

import authService from '../services/auth.service.js';
import toast from '../utils/toast.js';
import modal from '../utils/modal.js';
import router from '../router/router.js';

export default {
  render() {
    return `
      <div style="min-height: 100vh; display: flex; align-items: center; justify-content: center; background: linear-gradient(135deg, var(--primary) 0%, var(--primary-dark) 100%);">
        <div class="card" style="width: 100%; max-width: 400px; margin: var(--spacing-lg);">
          <div style="text-align: center; margin-bottom: var(--spacing-xl);">
            <img src="/img/agromx.png" alt="AGROMX" style="max-width: 200px; height: auto; margin-bottom: var(--spacing-sm);">
            <p style="color: var(--gray-600);">Sistema de Gestión de Tractores</p>
          </div>

          <form id="loginForm">
            <div class="form-group">
              <label class="form-label">Usuario</label>
              <input
                type="text"
                name="username"
                class="form-input"
                placeholder="Ingresa tu usuario"
                required
                autocomplete="username"
                autocapitalize="off"
              />
            </div>

            <div class="form-group">
              <label class="form-label">Contraseña</label>
              <input
                type="password"
                name="password"
                class="form-input"
                placeholder="••••••••"
                required
                autocomplete="current-password"
              />
            </div>

            <button type="submit" class="btn btn-primary" style="width: 100%; justify-content: center;" id="loginBtn">
              Iniciar Sesión
            </button>
          </form>
        </div>
      </div>
    `;
  },

  afterRender() {
    // Si el usuario ya está autenticado, no debería ver esta pantalla.
    // Esto pasa si presiona ← del navegador después de loguearse.
    // Lo regresamos al dashboard.
    if (authService.isAuthenticated()) {
      window.location.href = '/dashboard';
      return;
    }

    const form = document.getElementById('loginForm');
    const loginBtn = document.getElementById('loginBtn');

    form.addEventListener('submit', async (e) => {
      e.preventDefault();

      const formData = new FormData(form);
      const username = formData.get('username');
      const password = formData.get('password');

      // Deshabilitar botón
      loginBtn.disabled = true;
      loginBtn.textContent = 'Iniciando sesión...';

      try {
        await authService.login(username, password);
        toast.success('¡Bienvenido!');

        // Recargar la aplicación para mostrar el dashboard
        window.location.reload();
      } catch (error) {
        // Modal en lugar de toast — más visible y obliga al usuario a cerrarla.
        // Mensaje uniforme por seguridad: no diferenciamos "usuario no existe"
        // de "contraseña incorrecta" para no exponer info de cuentas válidas.
        const mensaje = error.message || 'Usuario o contraseña incorrectos';
        const esCredenciales = /credencial|invalid|incorrect|401/i.test(mensaje);
        modal.alert(
          esCredenciales ? 'No se pudo iniciar sesión' : 'Error',
          esCredenciales
            ? '<p>El usuario o la contraseña son incorrectos.</p><p style="margin-top:0.5rem;color:#6b7280;font-size:0.85rem;">Verifica tus datos e inténtalo de nuevo. Si el problema persiste, contacta al administrador.</p>'
            : `<p>${mensaje}</p>`
        );
        loginBtn.disabled = false;
        loginBtn.textContent = 'Iniciar Sesión';
      }
    });
  }
};
